var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6426,
    cy: 13,
    r: 12.3,
    stroke: "#989898",
    strokeWidth: 1.4,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1061_6743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7259 18.1333H18.7759V18.0833V17.1666C18.7759 17.0805 18.7248 16.9909 18.6463 16.9036C18.5665 16.8148 18.4514 16.7207 18.3081 16.6248C18.0212 16.4329 17.6146 16.2294 17.1319 16.0434C16.1665 15.6713 14.8895 15.3666 13.6426 15.3666C12.3956 15.3666 11.1186 15.6713 10.1532 16.0434C9.67054 16.2294 9.26395 16.4329 8.97706 16.6248C8.83376 16.7207 8.71865 16.8148 8.63878 16.9036C8.56031 16.9909 8.50922 17.0805 8.50922 17.1666V18.0833V18.1333H8.55922H18.7259ZM15.4426 9.66659C15.4426 8.6723 14.6368 7.86659 13.6426 7.86659C12.6483 7.86659 11.8426 8.6723 11.8426 9.66659C11.8426 10.6609 12.6483 11.4666 13.6426 11.4666C14.6368 11.4666 15.4426 10.6609 15.4426 9.66659ZM10.3592 9.66659C10.3592 7.85253 11.8285 6.38325 13.6426 6.38325C15.4566 6.38325 16.9259 7.85253 16.9259 9.66659C16.9259 11.4765 15.4566 12.9499 13.6426 12.9499C11.8285 12.9499 10.3592 11.4765 10.3592 9.66659ZM7.02589 17.1666C7.02589 16.6297 7.29417 16.1562 7.73916 15.7456C8.1845 15.3347 8.80351 14.9902 9.49498 14.7135C10.878 14.1602 12.5384 13.8833 13.6426 13.8833C14.7467 13.8833 16.4071 14.1602 17.7901 14.7135C18.4816 14.9902 19.1006 15.3347 19.546 15.7456C19.9909 16.1562 20.2592 16.6297 20.2592 17.1666V19.6166H7.02589V17.1666Z",
    fill: "#989898",
    stroke: "white",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_6743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(3.64258 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.f10016721efdfecae8c7550478df7307.svg";
export { ForwardRef as ReactComponent };